import * as Lucide from 'lucide-react'
import type { LucideProps } from 'lucide-react'

/**
 * Real SVG icons (Lucide). Replaces the old emoji-as-icon approach, which
 * rendered as missing-glyph boxes in the iOS WKWebView. Content `icon`
 * fields are Lucide names (e.g. "cloud-rain", "volume-x"); we resolve
 * kebab-case → PascalCase automatically, with a few aliases for names that
 * have no direct Lucide equivalent, and a safe fallback.
 */
const ALIASES: Record<string, string> = {
  running: 'Footprints',
  'person-running': 'Footprints',
  utensils: 'Utensils',
}

function toPascal(name: string): string {
  return name
    .split(/[-_ ]+/)
    .filter(Boolean)
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join('')
}

type IconProps = { name?: string | null; size?: number } & Omit<LucideProps, 'ref'>

export default function Icon({ name, size = 28, ...props }: IconProps) {
  const key = ALIASES[name ?? ''] ?? toPascal(name ?? '')
  const lib = Lucide as unknown as Record<string, React.ComponentType<LucideProps>>
  const Cmp = lib[key] ?? Lucide.Sparkles
  return <Cmp size={size} strokeWidth={2} aria-hidden {...props} />
}
